import { motion } from "framer-motion";
import { Pencil, StickyNote, Search, Plus } from "lucide-react";
import annotifyIcon from "../assets/annotify.png";
import { colors, tooltipVariants } from "../common/constants";
import Footer from "./Footer";

const LandingPage = () => {
    const extensionUrl =
    "https://chromewebstore.google.com/detail/jikphccfclhbejddcdmbfikbmdgkigoh?utm_source=item-share-cb";

  return (
    <div
      className="min-h-screen flex flex-col items-center px-4 relative overflow-hidden moving-gradient"
      style={{ color: colors.secondary }}
    >
      {/* Floating icons with reliable Framer-Motion tooltips */}
      <motion.div
        className="absolute top-12 left-6 cursor-pointer"
        style={{ color: colors.tealOption }}
        animate={{ y: [0, -10, 0] }}
        transition={{ repeat: Infinity, duration: 2 }}
        initial="hidden"
        whileHover="visible"
      >
        <Pencil size={40} />
        <motion.span
          variants={tooltipVariants}
          className="pointer-events-none z-20 absolute -bottom-10 left-4 transform -translate-x-1/2 text-white text-sm px-3 py-1 rounded-lg border border-white/30 bg-white/20 backdrop-blur-md whitespace-nowrap"
        >
          Add on spot notes to any web page
        </motion.span>
      </motion.div>

      <motion.div
        className="absolute top-32 right-10 cursor-pointer"
        style={{ color: colors.yellowOption }}
        animate={{ y: [0, -15, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        initial="hidden"
        whileHover="visible"
      >
        <StickyNote size={44} />
        <motion.span
          variants={tooltipVariants}
          className="pointer-events-none z-20 absolute -top-10 right-0 transform -translate-x-1/2 text-white text-sm px-3 py-1 rounded-lg border border-white/30 bg-white/20 backdrop-blur-md whitespace-nowrap"
        >
          Never lose that important blog or article again!
        </motion.span>
      </motion.div>

      <motion.div
        className="absolute bottom-20 left-12 cursor-pointer"
        initial="hidden"
        whileHover="visible"
      >
        <motion.div
          style={{ color: colors.redOption }}
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 12, ease: "linear" }}
        >
          <Search size={36} />
        </motion.div>
        <motion.span
          variants={tooltipVariants}
          className="pointer-events-none z-20 absolute -bottom-0 left-14 -translate-x-1/2 text-white text-sm px-3 py-1 rounded-lg border border-white/30 bg-white/20 backdrop-blur-md whitespace-nowrap"
        >
          Quick search from the list
        </motion.span>
      </motion.div>

      {/* Header */}
      <header className="text-center mt-16 z-10">
        <motion.img
          src={annotifyIcon}
          alt="Annotify Icon"
          className="w-20 h-20 mx-auto drop-shadow-lg"
          animate={{ scale: [1, 1.1, 1] }}
          transition={{ repeat: Infinity, duration: 2 }}
        />
        <h1 className="text-5xl font-extrabold mt-4" style={{ color: colors.accent }}>
          Annotify
        </h1>
        <p className="mt-3 text-lg text-white">
          Add <span style={{ color: colors.tealOption }}>fun notes</span> to any website 🎯
        </p>
        <motion.a
          href={extensionUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block mt-6 px-6 py-3 font-semibold rounded-full shadow-lg hover:opacity-90 transition"
          style={{
            backgroundColor: colors.accent,
            color: colors.primary,
          }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <div className="flex items-center gap-2">
            <Plus />
            <p>Add to Chrome</p>
          </div>
        </motion.a>
      </header>

      {/* Features */}
      <section className="mt-16 max-w-2xl w-full z-10">
        <h2 className="text-2xl font-bold text-center mb-6" style={{ color: colors.base }}>
          ✨ What makes it awesome
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            "📝 Add notes to any page instantly",
            "🔗 Saves notes with exact page URL",
            "📑 Right-click to quickly add notes",
            "✍ Save notes with selected text",
            "🔍 Search your notes anytime",
          ].map((text, i) => (
            <motion.div
              key={i}
              className="rounded-xl shadow-md p-5 hover:shadow-lg transition"
              style={{
                backgroundColor: colors.primary,
                border: `1px solid ${colors.secondary}40`,
                color: colors.accent,
              }}
              whileHover={{ scale: 1.05 }}
            >
              {text}
            </motion.div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default LandingPage;